import React, {memo, PropsWithChildren} from 'react';

import {VisualSizesEnum} from '../../styles/commonStyles';
import {Icon} from '../icon/icon';
import {BooleanInputProps} from './booleanInputTypes';
import {BooleanInputWithLabel} from './booleanInputWithLabel';

/*
 * Props.
 */

export type CheckBoxProps = BooleanInputProps;

/*
 * Component.
 */

/**
 * A labeled checkbox for opting into a boolean choice or selecting any number of items from a
 * list, with support for an indeterminate state to represent a partial selection. Use it when
 * selections are independent and multiple can be checked at once. For choosing exactly one option
 * among several, use RadioButton instead; for a setting that applies immediately, use Toggle instead.
 *
 * @summary for opting into a boolean choice or selecting multiple items from a list
 */
export const CheckBox = memo<PropsWithChildren<CheckBoxProps>>((props) => {
  const {
    onChange,
    className,
    isChecked,
    isDisabled,
    children,
    isIndeterminate,
    isMultiline,
    size = VisualSizesEnum.MEDIUM,
    color,
    shouldStopPropagation,
  } = props;

  return (
    <BooleanInputWithLabel
      className={className}
      onChange={onChange}
      isChecked={isChecked}
      isIndeterminate={isIndeterminate}
      isDisabled={isDisabled}
      checkedIndicator={<Icon name="check/outlined/16" />}
      size={size}
      type="checkbox"
      isMultiline={isMultiline}
      color={color}
      shouldStopPropagation={shouldStopPropagation}
    >
      {children}
    </BooleanInputWithLabel>
  );
});
